import React from 'react';
import { Dialog } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../config/languages';

interface LanguageModalProps {
  open: boolean;
  onClose: () => void;
}

const LanguageModal: React.FC<LanguageModalProps> = ({ open, onClose }) => {
  const { i18n, t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} className="fixed z-[10000] inset-0">
      {/* Overlay first, lower z-index */}
      <div className="fixed inset-0 bg-black/30 z-0" aria-hidden="true" />
      {/* Modal panel, higher z-index */}
      <div className="fixed inset-0 flex items-center justify-center z-10">
        <Dialog.Panel className="relative bg-[var(--color-surface)] rounded-2xl shadow-xl max-w-3xl w-full mx-4 max-h-[90vh] flex flex-col border border-[var(--color-border)]">
          {/* Header Section - Fixed */}
          <div className="p-6 pb-4 border-b border-[var(--color-border)]">
            <Dialog.Title className="text-2xl font-bold mb-2 text-[var(--color-text)]">{t('language.chooseLanguage')}</Dialog.Title>
            <Dialog.Description className="text-[var(--color-muted)]">
              {t('language.description')}
            </Dialog.Description>
          </div>
          
          {/* Scrollable Content Section */}
          <div className="flex-1 overflow-y-auto p-6 pt-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-3">
              {LANGUAGES.map(lang => (
                <button
                  key={lang.code}
                  onClick={() => {
                    i18n.changeLanguage(lang.code);
                    onClose();
                  }}
                  className={`text-left px-3 py-3 rounded-lg transition-colors w-full ${
                    i18n.language === lang.code 
                      ? 'font-bold border-2' 
                      : 'hover:bg-[var(--color-hover)] border-2 border-transparent'
                  }`}
                  style={i18n.language === lang.code ? { backgroundColor: 'var(--color-hover)', color: 'var(--color-text)', borderColor: 'var(--color-border)' } : undefined}
                >
                  <div className="text-base font-medium text-[var(--color-text)]">{lang.label}</div>
                  <div className="text-xs text-[var(--color-muted)] mt-1">{lang.english}</div>
                </button>
              ))}
            </div>
          </div>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl font-bold bg-[var(--color-surface)] rounded-full px-2 py-0.5"
            aria-label="Close language modal"
          >
            ×
          </button>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default LanguageModal; 